export const BRAND_NAME = 'PELLY HOMESTAY'
export const BRAND_TAGLINE = 'Your Home in Taveuni.'

export type NavItem = {
  label: string
  href: string
}

export const navItems: NavItem[] = [
  { label: 'Home', href: '#home' },
  { label: 'The House', href: '#house' },
  { label: 'Taveuni', href: '#taveuni' },
  { label: 'Location', href: '#location' },
  { label: 'FAQ', href: '#faq' }
]

export const images = {
  hero: 'https://cdn.magicpatterns.com/uploads/5MUY8zqTNJzBCW7XC3FRyD/PinLoad_Fiji_-_Taveuni_1787348398459.jpg',
  house: 'https://cdn.magicpatterns.com/patterns/generated-images/427d6e2a-2830-459b-8899-8b5e68613925.jpg',
  bedroom: 'https://cdn.magicpatterns.com/patterns/generated-images/ab8474a2-32e8-4896-92a6-3c79f38a4c76.jpg',
  living: 'https://cdn.magicpatterns.com/patterns/generated-images/71584c03-4278-4bd9-b456-ea6ed48cd969.jpg',
  bathroom: 'https://cdn.magicpatterns.com/patterns/generated-images/e05eaccd-02eb-451a-aad9-e9eb58b978e8.jpg',
  kitchen: 'https://cdn.magicpatterns.com/patterns/generated-images/64f5124c-f7ca-4186-8c8f-8d79067748e8.jpg',
  garden: 'https://cdn.magicpatterns.com/patterns/generated-images/f36a2933-fbe7-4721-a9e7-365a61ea17d2.jpg',
  outdoor: 'https://cdn.magicpatterns.com/patterns/generated-images/7fd7ad39-cfcb-4798-9cc0-1d4b18204df1.jpg',
  waterfall: 'https://cdn.magicpatterns.com/patterns/generated-images/3b9633c0-cbf2-4fde-8b73-1e4396f9d140.jpg',
  coastal: 'https://cdn.magicpatterns.com/patterns/generated-images/5f4a1cdc-d21b-43ca-9ab4-abdb68b04580.jpg',
  diving: 'https://cdn.magicpatterns.com/patterns/generated-images/8b122172-a079-4329-8900-fe820b071983.jpg',
  beach: 'https://cdn.magicpatterns.com/patterns/generated-images/44ff6193-fe4b-4c65-9b91-1fd3819b3359.jpg',
  dateline: 'https://cdn.magicpatterns.com/patterns/generated-images/fd6aecbd-5269-4578-842f-aae0cc4ebab5.jpg',
  cta: 'https://cdn.magicpatterns.com/patterns/generated-images/fbdc5a89-4fd7-4ac5-a402-26d19ac23d67.jpg'
}

export type CarouselPhoto = {
  src: string
  alt: string
  /** width / height of the original photograph, used to avoid any cropping */
  ratio: number
}

export const carouselPhotos: CarouselPhoto[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/b8qwSeoECwKScraiWwh6Uq/foto_galeria_principal_1.png',
    alt: 'Golden sunrise over the ocean from a quiet beach in Taveuni',
    ratio: 1536 / 1024
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7Xo1mQXRV6bpPnJTW3Y53H/imagen_mejorada_2.png',
    alt: 'Clear turquoise lagoon framed by tropical trees along the Taveuni coast',
    ratio: 1536 / 1024
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8CMYaCir3N78SStu3mE2Y9/imagen_mejorada_3.png',
    alt: 'Rainforest waterfall falling into a natural swimming pool in Taveuni',
    ratio: 1651 / 1004
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/79yJQGVUCrJeHBVQtUgsks/imagen_mejorada_4.png',
    alt: 'White sand beach and shallow turquoise water under a clear sky',
    ratio: 1536 / 1024
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2kwnsAzKvsZHe8BX7YZX4E/imagen_mejorada_5.png',
    alt: 'Aerial view of palm-lined coastline and reef break in Taveuni',
    ratio: 1449 / 1087
  }
]

export type Experience = {
  icon: 'home' | 'coffee' | 'leaf' | 'compass'
  title: string
  description: string
}

export const experiences: Experience[] = [
  {
    icon: 'home',
    title: 'LOCAL HOMESTAY',
    description:
      'Stay in a real Taveuni home and experience the island from a more personal perspective.'
  },
  {
    icon: 'coffee',
    title: 'BREAKFAST INCLUDED',
    description: 'Start your morning with a fresh homemade breakfast.'
  },
  {
    icon: 'leaf',
    title: 'TROPICAL SURROUNDINGS',
    description:
      'Slow down, relax, and enjoy the natural beauty surrounding your stay.'
  },
  {
    icon: 'compass',
    title: 'DISCOVER TAVEUNI',
    description:
      'Explore waterfalls, beaches, hiking trails, diving, snorkeling, and local experiences.'
  }
]

export type GalleryImage = {
  src: string
  alt: string
  /** 'contain' shows the whole photograph inside the tile without cropping */
  fit?: 'cover' | 'contain'
}

export const houseImages: GalleryImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/wdFeyLEU21dJ4ms18p1bzF/ChatGPT_Image_21_ago_2026,_07_35_12_p.m..png',
    alt: 'Timber house with a covered veranda and dining table facing the garden'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/54v5nRApjLr6GXfqNazRar/cc916ff8-ed8e-46a5-80ee-5a5af3840448.png',
    alt: 'Bedroom with a double bed, fresh white linen and folded towels'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/1isauBVbAnrXd81gwbM7Cz/ChatGPT_Image_21_ago_2026,_07_29_18_p.m..png',
    alt: 'Second bedroom with a wooden dresser and mirror beside the window'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/q7MfEdz5fxPDJ84K1diUhu/ChatGPT_Image_21_ago_2026,_07_33_08_p.m..png',
    alt: 'Kitchen with gas stove, fridge and timber cabinetry'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3r1YCGHhTKQJtvRc1tz79M/ChatGPT_Image_21_ago_2026,_07_46_09_p.m..png',
    alt: 'Kitchen counter with breakfast basics, crockery and a garden view'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tDJ3CL3kXhsC3menUhRLf7/ChatGPT_Image_21_ago_2026,_07_36_55_p.m..png',
    alt: 'Living area with a wall-mounted television'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ckqs6uRNRCt9v6f6M19txR/ChatGPT_Image_21_ago_2026,_09_54_28_p.m..png',
    alt: 'Lounge with sofas and armchairs beside bright curtained windows'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/me9HN7EQx7x8dSgGJYE3no/ChatGPT_Image_21_ago_2026,_09_55_25_p.m..png',
    alt: 'Lounge seating next to the breakfast bar with stools'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qaFUa7ymEDCVy2prp5W2iJ/ChatGPT_Image_21_ago_2026,_09_50_55_p.m..png',
    alt: 'Tiled shower room with a window above the shower head',
    fit: 'contain'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9NJdyVLP38VwJBWPXYoQeK/ChatGPT_Image_21_ago_2026,_07_39_42_p.m..png',
    alt: 'Private toilet with patterned tiled floor'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/n1WYEiyuWfJ36wqk2fjGJ1/ChatGPT_Image_21_ago_2026,_07_52_34_p.m..png',
    alt: 'Aerial view of the house and its green garden surrounded by trees'
  }
]

export type Amenity = {
  icon: 'wifi' | 'coffee' | 'car' | 'utensils' | 'towel' | 'trees'
  label: string
  note: string
  highlight?: string
}

export const amenities: Amenity[] = [
  {
    icon: 'wifi',
    label: 'Starlink Wi-Fi',
    note: 'The only homestay in Taveuni with high-speed Starlink internet — stream, video call and work from the island.',
    highlight: 'Exclusive'
  },
  { icon: 'coffee', label: 'Breakfast Included', note: 'Homemade, served daily' },
  { icon: 'car', label: 'Parking', note: 'Free on-site parking' },
  {
    icon: 'utensils',
    label: 'Full Gas Kitchen',
    note: 'A complete gas kitchen to cook for yourself — or order lunch and dinner at the homestay.'
  },
  { icon: 'towel', label: 'Towels & Linen', note: 'Provided for every stay' },
  { icon: 'trees', label: 'Outdoor Space', note: 'Garden and terrace' }
]

export type Destination = {
  title: string
  description: string
  image: string
  alt: string
}

export const destinations: Destination[] = [
  {
    title: 'BOUMA WATERFALLS',
    description: 'Explore lush rainforest trails and spectacular waterfalls.',
    image: images.waterfall,
    alt: 'Rainforest waterfall falling into an emerald pool'
  },
  {
    title: 'LAVENA COASTAL WALK',
    description: "Discover one of Taveuni's most beautiful coastal walks.",
    image: images.coastal,
    alt: 'Coastal trail along black sand and turquoise water'
  },
  {
    title: 'DIVING & SNORKELING',
    description: 'Experience the incredible marine life surrounding Taveuni.',
    image: images.diving,
    alt: 'Colourful soft coral reef underwater'
  },
  {
    title: 'BEACHES & NATURE',
    description: "Slow down and discover the island's natural beauty.",
    image: images.beach,
    alt: 'Quiet secluded tropical beach with a leaning palm'
  },
  {
    title: 'INTERNATIONAL DATE LINE',
    description: "Experience one of Taveuni's most unique geographical features.",
    image: images.dateline,
    alt: 'Grassy hillside viewpoint with a weathered marker post'
  }
]

export type Benefit = {
  title: string
  description: string
}

export const benefits: Benefit[] = [
  { title: 'LOCAL', description: 'Experience the island from a local perspective.' },
  { title: 'PERSONAL', description: 'Enjoy a more personal and welcoming stay.' },
  { title: 'AUTHENTIC', description: 'Discover a side of Fiji beyond traditional resorts.' },
  { title: 'SIMPLE', description: 'A comfortable place to relax, recharge, and explore.' }
]

export type Distance = {
  label: string
  time: string
}

export const distances: Distance[] = [
  { label: 'Taveuni Airport', time: 'XX min' },
  { label: 'Shops', time: 'XX min' },
  { label: 'Restaurants', time: 'XX min' },
  { label: 'Beach', time: 'XX min' },
  { label: 'Main Attractions', time: 'XX min' }
]

export type ArrivalStep = {
  step: string
  title: string
  description: string
}

export const arrivalSteps: ArrivalStep[] = [
  {
    step: '01',
    title: 'Land at Taveuni Airport',
    description: 'Domestic flights arrive from Nadi and Suva throughout the day.'
  },
  {
    step: '02',
    title: 'Meet your transfer',
    description: 'We can arrange a private pick-up, or taxis wait outside the terminal.'
  },
  {
    step: '03',
    title: 'Drive along the coast',
    description: 'A scenic XX minute drive through villages and rainforest.'
  },
  {
    step: '04',
    title: 'Arrive at the house',
    description: 'We welcome you, show you around, and settle you in.'
  }
]

export type Review = {
  name: string
  country: string
  flag: string
  score: string
  title: string
  date: string
  text: string
  negative?: string
}

export const reviews: Review[] = [
  {
    name: 'Maria',
    country: 'Spain',
    flag: '🇪🇸',
    score: '8.0',
    title: 'Fantastic authentic Fijian food and a great family atmosphere',
    date: '19 July 2026',
    text:
      'The food is excellent. Very warm family atmosphere. The village is very friendly.',
    negative:
      'There were fuel supply problems on the island, which affected some services.'
  },
  {
    name: 'Kat',
    country: 'Australia',
    flag: '🇦🇺',
    score: '10',
    title: 'Exceptional',
    date: '28 July 2026',
    text:
      'Pelly is a wonderful and caring host. It is a beautiful village and family who made us feel very welcome, provided amazing food for us and organised many activities for us. The local kids love spending time with you and including you in games and cards. It matched the description provided.'
  },
  {
    name: 'Bryan',
    country: 'France',
    flag: '🇫🇷',
    score: '10',
    title: 'Exceptional',
    date: '4 June 2026',
    text:
      'Louis welcomed us into his family with remarkable kindness. The village welcomed us as one of their own, and the experience was truly fantastic. If you want to experience real Fijian life and culture, I highly recommend this adventure with Louis. His family is lovely, and we learned so much about Fijian life by staying with them. The village children are incredible, and spending time with them is a wonderful experience. The village is also close to many waterfalls and points of interest on the island. If you can bring school supplies for the children, that would be greatly appreciated — they have limited resources at school, and even a small contribution can make a difference. The food is local, generous and very good, and there are also many activities available.'
  },
  {
    name: 'Miroslav',
    country: 'Czech Republic',
    flag: '🇨🇿',
    score: '10',
    title: 'Exceptional',
    date: '3 April 2026',
    text:
      'Experience Fiji differently! If you want to experience local culture, community and real Fijian life, where people will go out of their way to make you feel welcome, come here. Hotels will take care of you normally, but Vurevure goes above and beyond. Thank you so much, Emma & Lui!'
  },
  {
    name: 'Michael',
    country: 'Australia',
    flag: '🇦🇺',
    score: '8.0',
    title: 'Great homestay in a village',
    date: '18 November 2025',
    text:
      'Friendly people, wonderful food, and a great experience of a Fijian village and community.'
  }
]

export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is breakfast included?',
    answer:
      'Yes. A fresh homemade breakfast is included with every stay and is served each morning at the house. Placeholder — exact serving times to be confirmed.'
  },
  {
    question: 'How do I get to the house?',
    answer:
      'Most guests fly into Taveuni Airport and continue by taxi or private transfer. The drive takes approximately XX minutes. Placeholder — exact directions to be confirmed.'
  },
  {
    question: 'How many guests can stay?',
    answer:
      'The house comfortably accommodates up to X guests. Placeholder — room configuration and maximum occupancy to be confirmed.'
  },
  {
    question: 'Is Wi-Fi available?',
    answer:
      'Yes. We are the only homestay in Taveuni with Starlink, so you get fast, reliable Wi-Fi throughout your stay — enough to stream, video call or work remotely from the island.'
  },
  {
    question: 'Is airport transfer available?',
    answer:
      'Airport transfers can be arranged on request. Let us know your flight details when you book. Placeholder — transfer rates to be confirmed.'
  },
  {
    question: 'Are restaurants nearby?',
    answer:
      'There are local restaurants and shops approximately XX minutes away. Placeholder — nearby dining options to be confirmed.'
  },
  {
    question: 'Can I rent a car?',
    answer:
      'Yes. A rental car or scooter is the easiest way to explore the island, and we are happy to point you to local providers.'
  },
  {
    question: 'Can you help arrange activities?',
    answer:
      'Absolutely. We can help arrange waterfall trips, guided walks, diving, snorkeling, and local experiences with people we know and trust.'
  }
]

export const bookingUrl =
  'https://www.booking.com/searchresults.html?ss=PELLY+Homestay+Explorer%2C+Vunivuthea'

export const whatsappNumber = '6799845523'
export const whatsappMessage =
  "Hi! I'm interested in staying at your homestay in Fiji. I have a few questions."
export const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
  whatsappMessage
)}`

export const contact = {
  location: 'Taveuni, Fiji',
  whatsapp: 'WhatsApp — +679 984 5523',
  email: 'hello@placeholder.com',
  instagram: '@placeholder'
}
